import React from "react";
import PropTypes from "prop-types";

const PullRopesIcon = ({
  width,
  height,
  className,
  color,
  stroke,
  strokeWidth,
  ...props
}) => {
  const strokeColor =
    stroke && stroke !== "currentColor" ? stroke : color || "currentColor";

  return (
    <svg
      width={width || 16}
      height={height || 16}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      {...props}
    >
      <g clipPath="url(#pull-ropes-icon-clip)">
        <path
          d="M2.46897 9.64505C0.568553 7.38702 1.09875 4.34641 3.69905 2.59066C6.29936 0.834908 10.1352 0.927542 12.5984 2.80557C15.0616 4.68361 15.3615 7.74427 13.2943 9.90647C11.2271 12.0687 7.45622 12.6385 4.54563 11.2284"
          stroke={strokeColor}
          strokeWidth={strokeWidth || "1.33333"}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M4.66732 14.6666C3.82909 14.0379 3.33524 13.0517 3.33398 12.0039"
          stroke={strokeColor}
          strokeWidth={strokeWidth || "1.33333"}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M2 10.6663C2 11.4022 2.59745 11.9997 3.33333 11.9997C4.06922 11.9997 4.66667 11.4022 4.66667 10.6663C4.66667 9.93045 4.06922 9.33301 3.33333 9.33301C2.59745 9.33301 2 9.93045 2 10.6663V10.6663"
          stroke={strokeColor}
          strokeWidth={strokeWidth || "1.33333"}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="pull-ropes-icon-clip">
          <rect width="16" height="16" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

PullRopesIcon.propTypes = {
  width: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  height: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  className: PropTypes.string,
  color: PropTypes.string,
  stroke: PropTypes.string,
  strokeWidth: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
};

PullRopesIcon.defaultProps = {
  width: undefined,
  height: undefined,
  className: "",
  color: undefined,
  stroke: undefined,
  strokeWidth: undefined,
};

export default PullRopesIcon;
